import { serviceName } from '@eigtech/claims-v2-types';
import { ensureClaimV2Corn, isClaimV2Corn, makeClaimV2Corn } from '@eigtech/claims-v2-util';
import { getCornKernels } from '@eigtech/shared-corn';
export const currentClaimCornService = serviceName;
export const makeClaimCorn = makeClaimV2Corn;
export const ensureClaimCorn = ensureClaimV2Corn;
export const isClaimCorn = isClaimV2Corn;
export const ensureClaimNumber = (entityId) => getCornKernels(ensureClaimCorn(entityId)).resourceId;
